import { AxiosError } from 'axios';
import { PaymentAccessResponse } from 'web-library/models/Payment';
import { GET_POST_PAYMENT_ACCESS_URL } from 'web-library/constants/apiUrls';
import { GET_PAYMENT_ACCESS_QUERY_KEY } from 'web-library/constants/queryKeys';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: PaymentAccessResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetPaymentAccess = ({ onError, onSuccess }: Input = {}) => {
  const getPaymentAccess = async () => {
    const res = await axiosClient.get<PaymentAccessResponse>(GET_POST_PAYMENT_ACCESS_URL);

    return res.data;
  };

  return useCustomQuery(GET_PAYMENT_ACCESS_QUERY_KEY, getPaymentAccess, {
    onSuccess,
    onError,
  });
};
